var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Location",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3376",
    "data-name": "Rectangle 3376",
    width: 15,
    height: 20,
    fill: "#1b453e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3558",
    "data-name": "Group 3558",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M14.923,6.36a7.148,7.148,0,0,0-2.142-4.2A7.385,7.385,0,0,0,6.027.144,7.138,7.138,0,0,0,2.869,1.587,7.35,7.35,0,0,0,.3,5.364,6.725,6.725,0,0,0,.107,8.517a9.261,9.261,0,0,0,1.456,3.474L2.95,14.072c1.135,1.7,2.309,3.464,3.46,5.2a1.617,1.617,0,0,0,.889.723L7.322,20h.357l.023-.007a1.612,1.612,0,0,0,.89-.723c.505-.763,1.021-1.536,1.52-2.285.545-.816,1.109-1.661,1.659-2.494q.266-.4.534-.8c.543-.81,1.106-1.648,1.6-2.505A7.27,7.27,0,0,0,14.923,6.36M13.778,7.854a6.225,6.225,0,0,1-.935,2.8c-.648,1.037-1.337,2.074-2,3.078q-.24.362-.479.723c-.693,1.048-1.4,2.11-2.088,3.137l-.72,1.079c-.016.025-.034.05-.054.076L7.466,18.7,6.3,16.946C5.068,15.1,3.8,13.2,2.554,11.327A7.839,7.839,0,0,1,1.242,8.051,5.613,5.613,0,0,1,1.5,5.493,6.188,6.188,0,0,1,3.849,2.337,6,6,0,0,1,6.624,1.245a7.9,7.9,0,0,1,.922-.056,6.1,6.1,0,0,1,4.807,2.262,5.8,5.8,0,0,1,1.425,4.4",
    fill: "#1b453e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M7.509,3.414H7.5A4.033,4.033,0,0,0,4.647,4.585a3.974,3.974,0,0,0-.009,5.675A4.039,4.039,0,0,0,7.5,11.435h0a4.041,4.041,0,0,0,2.863-1.178A3.958,3.958,0,0,0,11.549,7.42a4.04,4.04,0,0,0-4.04-4.006M10.358,7.43a2.8,2.8,0,0,1-.845,2,2.853,2.853,0,0,1-2.012.826H7.492a2.853,2.853,0,0,1-2.85-2.822,2.79,2.79,0,0,1,.837-2A2.847,2.847,0,0,1,7.5,4.6h0a2.846,2.846,0,0,1,2.016.835,2.788,2.788,0,0,1,.84,2",
    fill: "#1b453e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.04d408def19d474c2529b47c0268419d.svg";
export { ForwardRef as ReactComponent };